import React from "react"
import { useTranslation } from "react-i18next"

import { Layout } from "~/components/Layout/Layout"

import { List } from "./components/List/List"

const Calendar: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout headerTheme="onLight" title={t("page.calendar")}>
      <List />
    </Layout>
  )
}

export default Calendar
